import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useProfile } from '../profile/ProfileProvider';
import type { ToolSlug } from '@daaily/shared';

/**
 * Route guard: render children only if the user has provisioned access to
 * the named tool. Otherwise redirect to the hub. The hub itself surfaces
 * a "request access" UI for users with no tools, so this redirect is
 * always toward a useful page (never a dead end).
 */
export function RequireToolAccess({
  slug,
  children,
}: {
  slug: ToolSlug;
  children: ReactNode;
}) {
  const { state: profileState } = useProfile();

  // Should never reach here without a 'ready' profile (App.tsx renders
  // splash/contact-HR for other states), but defend anyway.
  if (profileState.status !== 'ready') return null;

  const tools = profileState.user.tools ?? {};
  const entry = tools[slug as keyof typeof tools];
  if (!entry?.enabled) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
